import React, { useState, useEffect, useRef } from 'react'
import { message, Dropdown } from 'antd'
import classnames from 'classnames'
import './tagSelection.less'
import Icon from '../icon'
import Input from '../../baseComponent/input'
import History from './tagSelection.history'
import LoaclHistory from './tagSelection.localHistory'

const MAX_LENGTH = 21

export default function TagList({
  value,
  disabled,
  overlayStyle,
  onChange,
  maxSize = 20,
  className,
  smartTags,
  showSmartTags,
  type, localKey, localType, closeFold, wrapStyle, ...otherProps }) {
  const [tags, setTags] = useState(new Set())
  const [keyword, setKeyword] = useState('')
  const [isFold, setIsfold] = useState(true)
  const [wrapHeight, setWrapHeight] = useState(0)
  const $tagContainer = useRef()
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    setWrapHeight($tagContainer?.current?.scrollHeight)
  }, [tags])

  useEffect(() => {
    if (value instanceof Array) {
      const notEmpty = value?.filter(m => m && typeof m === 'string' && m.trim())
      setTags(new Set(notEmpty))
    }
    if (value instanceof Set) {
      setTags(new Set(value))
    }
  }, [value])
  const onAdd = (tag) => {
    tags.add(tag)
    setTags(new Set(tags))
    onChange && onChange(tags)
  }
  const onDelete = (tag) => {
    tags.delete(tag)
    setTags(new Set(tags))
    onChange && onChange(tags)
  }
  const events = {
    onAddTag: (tag) => {
      if (!tag) {
        return
      }
      if (tags.size >= maxSize) {
        message.error(`标签个数不可超过${maxSize}个哦`)
        return
      }
      onAdd?.(tag)
    },
    onKeyDown(e) {
      if (e.keyCode === 13) {
        if (e.target.value.trim().length <= 0) {
          return
        }
        events.onClickSearchItem(e.target.value)
      }
    },
    onChange(e) {
      if (e.target.value.length >= MAX_LENGTH) {
        // message.error(`单个标签字数不可超过${MAX_LENGTH - 1}字哦～`)
        return
      }
      // setLoading(!!e.target.value)
      setKeyword(e.target.value)
    },
    onClickSearchItem(tagName) {
      setKeyword('')
      events.onClickItem(tagName)
    },
    onClickItem(tagName) {
      if (tags.has(tagName)) {
        // 执行删除操作
        onDelete?.(tagName)
        return
      }
      if (tags.size >= maxSize) {
        message.error(`标签个数不可超过${maxSize}个哦`)
        return
      }
      // 添加操作
      onAdd?.(tagName)
    },
    onTagClick(tag, e) {
      e.stopPropagation()
      !disabled && onDelete?.(tag)
    },
  }
  return <div className="mn-tag-container" style={wrapStyle}>
    {tags?.size > 0 && <div className="mn-tag-wrap">
      <div className="tag-container" ref={$tagContainer} style={{ height: isFold ? 33 : '', overflow: 'hidden' }}>
        {Array.from(tags)?.reverse().map(tag => <span
          key={tag}
          className="tag"
          onClick={e => events.onTagClick(tag, e)}
        >{tag}<Icon type="m-guanbi" /></span>)}
        {(!isFold && wrapHeight != 33) && <span className="tag tag-xiangshang" onClick={() => setIsfold(true)}><Icon type="m-Vxing_shang" /></span>}
      </div>
      {(isFold && wrapHeight != 33) && <span onClick={() => !closeFold && setIsfold(false)} className="tag tag-more">{`+${tags.size}...`}</span>}
    </div>}
    {/* 下方div给Dropdown定位用，防止添加标签后位置错误 */}
    <div style={{ position: 'relative' }}>
      <Dropdown
        open={visible}
        onOpenChange={vis => setVisible(vis)}
        getPopupContainer={node => node.parentElement || document.body}
        trigger="click"
        overlay={!disabled ? <div style={overlayStyle}>
          {
            type === 'fetchInterface' ? <History
              keyword={keyword}
              setKeyword={setKeyword}
              value={tags}
              smartTags={smartTags}
              showSmartTags={showSmartTags}
              onDelete={tagName => !disabled && onDelete?.(tagName)}
              onAdd={tagName => events.onAddTag(tagName)}
            /> : <LoaclHistory
              localKey={localKey}
              localType={localType}
              keyword={keyword}
              setKeyword={setKeyword}
              value={tags}
              onDelete={tagName => !disabled && onDelete?.(tagName)}
              onAdd={tagName => events.onAddTag(tagName)}
            />
          }
        </div> : <span />}
      >
        <div className={classnames('mn-add-inspiration-tag-wrapper', className)} {...otherProps}>
          <div className={classnames('tags', { disabled })}>
            <Input
              disabled={disabled}
              placeholder="点击输入，按回车添加"
              value={keyword}
              maxLength={20}
              onFocus={() => setVisible(true)}
              // onBlur={() => setVisible(false)}
              wrapClassName="tag-input"
              onKeyDown={e => events.onKeyDown(e)}
              onInput={e => events.onChange(e)}
            />
            <div className="suffix">{`${tags.size}/20`}</div>
          </div>
        </div>
      </Dropdown>
    </div>
  </div>
}
